import cn from 'classnames/bind'
import styles from './CellTypeMoney.module.scss'
import { isValueZero } from './isValueZero'
import { EncashmentsStatusType } from 'app/dataTypes/reports/data'

const cx = cn.bind(styles)

type Props = {
  value: string
  status?: EncashmentsStatusType | null
}

export const CellTypeMoney = ({ value, status }: Props) => {
  const zero = isValueZero(value)

  return (
    <span className={cx(styles.root, { zero })}>
      {value === null || status === EncashmentsStatusType.CashNotDeposited ? '—' : value}
    </span>
  )
}
